import CheckingLocationPopup from 'components/popups/CheckingLocationPopup'
import { ReactComponent as MagDetails } from 'assets/magDetails.svg'
import { ReactComponent as Arrow } from 'assets/circleArrow.svg'
import type { Navigate } from 'hooks/useNavigateWithScrollSave'
import { selectWarehouse, updateWarehouseState } from '../Warehouses/warehousesSlice'
import { ReactComponent as Compass } from 'assets/compass.svg'
import useWarehouseAction from './hooks/useWarehouseAction'
import BigCircleBtn from 'components/buttons/BigCircleBtn'
import CodePreview from './MagAccess/popups/CodePreview'
import { ReactComponent as Gate } from 'assets/gate.svg'
import CircleBtn from 'components/buttons/CircleBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { STATUS } from 'utils/constants'
import { useReduxDispatch, useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { SECTION_TYPES } from '.'
import React from 'react'

interface MagActionsProps {
  id: string
  expanded: boolean
  toggleMenu: basic.BasicFunc
  navigate: Navigate
}

const type = process.env.REACT_APP_TYPE

const MagActions: React.FC<MagActionsProps> = ({ id, expanded, toggleMenu, navigate }) => {
  const { doorState, hasOnlineAccess, gateHasOnlineAccess, placeAddress, isAlreadyOpened, inFuture, hasAccess, placeGps, hasCodes, isShared, contractId, rentableType } = useReduxSelector(state => selectWarehouse(state, id))
  const { disabled, hasPermissionsToOpen, action } = useWarehouseAction(id)
  const config = useReduxSelector(selectConfig)

  const { goBack } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('warehouse')
  const { popup, openPopup } = usePopupState<{ type: 'codePreview' | 'checkingMagLocation' }>()

  const gateDisabled = !(gateHasOnlineAccess && hasPermissionsToOpen) || inFuture || !hasAccess

  return (
    <>
      {popup?.type === 'checkingMagLocation' && <CheckingLocationPopup
        targetPosition={(placeGps && placeGps.length === 2) ? {
          lat: Number(placeGps[0]),
          lng: Number(placeGps[1])
        } : undefined}
        callback={(success) => {
          if (success) {
            if (!isAlreadyOpened) navigate(`/firstopening/${id}`, true)
            else {
              goBack()
              action()
            }
          } else {
            goBack()
          }
        }}
      />}

      {popup?.type === 'codePreview' && <CodePreview
        contractId={contractId}
      />}

      <div className='menu__buttons --top'>
        {(hasCodes && !isShared)
          ? <CircleBtn
            Icon={'pin'}
            disabled={!hasAccess}
            text={t('accessCode')}
            action={() => {
              openPopup({ type: 'codePreview' })
            }}
          />
          : <CircleBtn
            Icon={Compass}
            text={t('navigate')}
            action={() => {
              window.open(`https://www.google.com/maps/search/?api=1&query=${placeAddress}`)
            }}
          />}

        <div className='buttons__col center'>
          {(hasOnlineAccess || (type === 'ldz01' && rentableType === 'warehouse'))
            ? <div style={disabled && type !== 'ldz01' ? { opacity: 0.5 } : undefined}>
              <BigCircleBtn
                text={doorState?.door === 'opened'
                  ? t('doorOpen')
                  : doorState?.lock === 'unlocked'
                    ? t('pullTheDoor')
                    : t(`openWarehouse.${type}`)}
                status={doorState?.door === 'opened'
                  ? STATUS.succeed
                  : doorState?.lock === 'unlocked'
                    ? STATUS.pending
                    : STATUS.idle}
                action={() => {
                  if (type === 'ldz01') {
                    dispatch(updateWarehouseState({ id, doorState: { door: doorState.door === 'opened' ? 'closed' : 'opened' } }))
                    return
                  }

                  if (disabled) return
                  if (config?.warehouseLocationCheckEnabled) openPopup({ type: 'checkingMagLocation' })
                  else if (!isAlreadyOpened) navigate(`/firstopening/${id}`)
                  else action()
                }} />
            </div>
            : <div style={gateDisabled ? { opacity: 0.5 } : undefined}>
              <BigCircleBtn
                disabled={gateDisabled}
                text={t(gateHasOnlineAccess ? 'openTheGate' : `openWarehouse.${type}`)}
                action={() => {
                  if (gateDisabled) return
                  navigate(`/warehouses/${id}/gate`)
                }} />
            </div>}

          {!expanded && <CircleBtn
            text={t('manage')}
            Icon={Arrow}
            action={toggleMenu} />}
        </div>

        {hasOnlineAccess
          ? <CircleBtn
            disabled={gateDisabled}
            text={t('openTheGate')}
            Icon={Gate}
            action={() => {
              navigate(`/warehouses/${id}/gate`)
            }}
          />
          : <CircleBtn
            text={t('rentalDetails')}
            Icon={MagDetails}
            action={() => {
              if (!window.location.pathname.includes(SECTION_TYPES.details)) {
                navigate(`/warehouses/${id}/${SECTION_TYPES.details}`)
              }
            }}
          />}
      </div>
    </>
  )
}

export default MagActions